import { useCallback, useEffect } from 'react'
import { Unsubscribe } from 'firebase/firestore'
import { useSelector, useDispatch } from '../../redux/hooks'
import authSelectors from '../../redux/modules/auth/selectors'
import authActions from '../../redux/modules/auth/actions'
import userAuthTriggerService from '../../services/userAuthTriggerService'
import authService from '../../services/authService'

export const useRefreshAuthTokenOnClaimsChange = () => {
  const dispatch = useDispatch()
  const userId = useSelector(authSelectors.getUserId)
  const refreshAuthToken = useCallback(async () => {
    const token = await authService.refreshToken().catch(() => undefined)
    if (token?.companyId && token?.role) {
      dispatch(authActions.tokenUpdated({ companyId: token.companyId, role: token.role }))
    }
    if (token?.email_verified) {
      dispatch(authActions.verified())
    }
  }, [dispatch])

  useEffect(() => {
    let unsubscribe: Unsubscribe
    if (userId) {
      void refreshAuthToken()
      unsubscribe = userAuthTriggerService.subscribeToUserAuthTriggerVersion({
        userId,
        onUserAuthTriggerIncremented: refreshAuthToken,
      })
    }
    return () => {
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [refreshAuthToken, userId])
}
